module.exports = __webpack_public_path__ + "assets/media/connect.1da30e9f.svg";